import * as query from "@arcgis/core/rest/query.js";

export default {
    getFacilityExtent(facilityId) {
        return this.getFacilitiesExtent([facilityId]);
    },

    getFacilitiesExtent(facilityIds) {
        const queryExtentUrl =
            "https://services.gis.msu.edu/ags-infrastructure/rest/services/Infrastructure/Buildings/FeatureServer/1";

        return query
            .executeForExtent(queryExtentUrl, {
                where: this.buildWhereClause(facilityIds),
            })
            .then((results) => {
                console.info("query extent results:", results);
                return results.count >= 1 ? results.extent : null;
            });
    },

    buildWhereClause(facilityIds) {
        let whereClause = "BUILDINGID IN (";

        let cnt = 0;
        facilityIds.forEach((facilityId) => {
            whereClause += `'${facilityId}'`;
            if (cnt < facilityIds.length - 1) {
                whereClause += ", ";
            }
            cnt++;
        });
        whereClause += ")";

        console.info("Extent query.where=" + whereClause);
        return whereClause;
    },
};
